import { render, staticRenderFns } from "./MultiviewPage.vue?vue&type=template&id=1284956f&scoped=true&"
import script from "./MultiviewPage.vue?vue&type=script&lang=js&"
export * from "./MultiviewPage.vue?vue&type=script&lang=js&"
import style0 from "./MultiviewPage.vue?vue&type=style&index=0&id=1284956f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284956f",
  null
  
)

export default component.exports